import { IInsightsParams, IOrganisationInsightsResponse } from 'shared';

import { orgHeader } from '../../../../common/lib/axiosBaseQuery';
import { emptySplitApi } from '../baseApi';

export type IFetchOrganisationInsightsArgs = Pick<
  IInsightsParams,
  `asOfDate` | `groupId` | `tags` | `excludeTags` | `excludeGroupIds` | `assignedUserId` | `history`
> & {
  organisationId: string;
};

export const insightsApi = emptySplitApi.injectEndpoints({
  endpoints: builder => ({
    fetchOrganisationInsights: builder.query<IOrganisationInsightsResponse, IFetchOrganisationInsightsArgs>({
      query: ({ organisationId, ...params }) => ({
        url: `insights`,
        method: `GET`,
        params,
        headers: {
          [orgHeader]: organisationId,
        },
      }),
    }),
  }),
});

export const {
  useFetchOrganisationInsightsQuery,
} = insightsApi;
